import { render, staticRenderFns } from "./HeadlineCate.vue?vue&type=template&id=5c997584&"
import script from "./HeadlineCate.vue?vue&type=script&lang=js&"
export * from "./HeadlineCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports